// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1_ub2","checkboxCol":"Table_checkboxCol__3nW68","emailCol":"Table_emailCol__pJkL4","actionCol":"Table_actionCol__3oU6T"};